import React from "react";
import { motion } from "framer-motion";

const LatestBadge = ({ className = "" }) => {
  const badgeStyle = {
    position: "absolute",
    top: "8px",
    right: "8px",
    backgroundColor: "#FF6B6B",
    color: "white",
    padding: "6px 12px",
    borderRadius: "20px",
    fontSize: "0.75rem",
    fontWeight: "bold",
    zIndex: 10,
    boxShadow: "0 2px 8px rgba(255, 107, 107, 0.3)",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    background: "linear-gradient(135deg, #FF6B6B, #FF5252)",
  };

  const pulseAnimation = {
    initial: { scale: 1 },
    animate: {
      scale: [1, 1.05, 1],
    },
    transition: {
      duration: 2,
      repeat: Infinity,
      repeatType: "loop",
    },
  };

  return (
    <motion.div
      className={className}
      style={badgeStyle}
      initial="initial"
      animate="animate"
      variants={pulseAnimation}
    >
      Latest
    </motion.div>
  );
};

export default LatestBadge;
